import { Box, Button, Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { TitlePages } from '@/components/Base/TitlePage';
import KpiComponent from '@/components/Base/KpiComponent';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import dayjs from 'dayjs';
import ColumnChartEntradasSaidasIpca from '@/components/Base/ColumnChartEntradasSaidasIpca';
import ColumnChartSuperavitDefasagem from '@/components/Base/ColumnChartSuperavitDefasagem';
import { useNavigate } from 'react-router-dom';
import { useIndiceValorKpis } from './api/getIndiceValorKpis';
import LoadingSummary from './components/LoadingSummary';
import { useIndiceValorGraficos } from './api/getIndiceValorGraficos';
import LoadingChart from './components/LoadingChart';

const IndiceValor = () => {
  const generateLastYears = (numYears) => {
    const currentYear = dayjs().year();
    return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
  };
  const navigate = useNavigate();
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const { data: kpis, isFetched: isFetchedKpis, isFetching: isFetchingKpis } = useIndiceValorKpis();
  const { data: graficos, isFetched: isFetchedGraficos, isFetching: isFetchingGraficos } = useIndiceValorGraficos();

  return (
    <>
      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <TitlePages title={'Índice de valor'} />

        <Stack flexDirection={'row'} gap={'20px'}>
          <Button
            sx={{
              p: '0 15px',
              borderRadius: '24px',
              fontSize: '14px',
              height: '30px',
              color: '#fff !important',
              weight: '700',
              background: '#15AB51',
              fontWeight: 700,
              textTransform: 'capitalize',
            }}
            variant="contained"
            onClick={() => navigate('/indice-configuracoes-avancadas')}
          >
            Configurações avançadas
          </Button>
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isFetchingKpis && <LoadingSummary />}
        {kpis && !isFetchingKpis && (
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#E04A4C #f1f1f1',
              }}
            >
              <KpiComponent title={'Total de inadimplência ano atual'} 
                value={`${kpis.total_inadimplance_year}%`} 
                tooltipText={'Total de inadimplência no ano atual.'}
                style={{minWidth: '160px'}}
              />

              <KpiComponent title={'Total de inadimplência mês atual'} 
                value={`${kpis.total_inadimplance}%`} 
                tooltipText={'Total de inadimplência no mês atual.'}
                style={{minWidth: '160px'}}
              />

              <KpiComponent
                title={'Total de inadimplência acumulada'}
                value={`${kpis.total_accumulated_inadimplance}%`}
                tooltipText={'Total de inadimplência acumulada considerando todos os anos.'}
                style={{minWidth: '160px'}}
              />
            </Stack>
          </Stack>
        )}

        <Box marginTop={'10px'} marginBottom={'25px'}>
          {/* <PeriodFilterDash
            startDate={selectedStartDate}
            endDate={selectedEndDate}
            onStartDateChange={setSelectedStartDate}
            onEndDateChange={setSelectedEndDate}
            refetchDashboard={() => console.log('teste')}
            listYears={listYears}
            setSelectedYear={setSelectedYear}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            selectedMonth={selectedMonth}
          /> */}
        </Box>

        <Box m={'40px 0'}>
          <LoadingChart loading={isFetchingGraficos} />
          {isFetchedGraficos &&  !isFetchingGraficos && (
            <ColumnChartEntradasSaidasIpca rawData={graficos?.student_movement_ipca_history || []} />
          )}
        </Box>

        <LoadingChart loading={isFetchingGraficos} />
        {isFetchedGraficos &&  !isFetchingGraficos && <ColumnChartSuperavitDefasagem rawData={graficos?.superavit_defasagem_history || []} />}
      </Box>
    </>
  );
};

export default IndiceValor;
